/**
 * Presets Grumft (ids de container + zona) — alinhados ao tvfoco-frontend.
 */
export const GRUMFT_IAB_PRESETS = {
  categorySidebar: {
    containerId: 'div_ZONA_IAB_336x280_cat',
    grumftZone: 'ZONA_IAB_336x280_3',
  },
  categoryAds1: {
    containerId: 'div_ZONA_IAB_336x280_6',
    grumftZone: 'ZONA_IAB_336x280_2',
  },
  categoryAds2: {
    containerId: 'div_ZONA_IAB_336x280_7',
    grumftZone: 'ZONA_IAB_336x280_5',
  },
  zone336x280_2: {
    containerId: 'div_ZONA_IAB_336x280_2',
    grumftZone: 'ZONA_IAB_336x280_2',
    slotHeightPx: 300,
  },
  zone336x280_3: {
    containerId: 'div_ZONA_IAB_336x280_3',
    grumftZone: 'ZONA_IAB_336x280_3',
  },
  zone336x280_5: {
    containerId: 'div_ZONA_IAB_336x280_5',
    grumftZone: 'ZONA_IAB_336x280_5',
  },
  zone336x280_7: {
    containerId: 'div_ZONA_IAB_336x280_7',
    grumftZone: 'ZONA_IAB_336x280_7',
  },
  zone336x280_13: {
    containerId: 'div_ZONA_IAB_336x280_13',
    grumftZone: 'ZONA_IAB_336x280_13',
  },
  zone728x90: {
    containerId: 'div_ZONA_IAB_728x90_1',
    grumftZone: 'ZONA_IAB_728x90',
    slotHeightPx: 100,
  },
  zone320x50: {
    containerId: 'div_ZONA_IAB_320x50_1',
    grumftZone: 'ZONA_IAB_320x50',
    slotHeightPx: 60,
  },
};

export const GRUMFT_SCRIPT_HASH = 'e3ea3eedd7082caf89fb798379bc5aaa.js';
export const GRUMFT_GT_ORIGIN = 'https://api.grumft.com';
export const GRUMFT_STICK_FOOTER_SRC =
  'https://api.grumft.com/stick/5498/5498_STICK_320x50_4.js';

export function buildGrumftScriptSrc(grumftZone) {
  const zone = String(grumftZone || '').trim();
  if (!zone) return '';
  return `${GRUMFT_GT_ORIGIN}/gt/${zone}/${GRUMFT_SCRIPT_HASH}`;
}

/** true volta aos scripts api.grumft.com; o padrão é o GPT direto com os mesmos ad units. */
export function isGrumftScriptTagsEnabled() {
  return process.env.NEXT_PUBLIC_GRUMFT_TAGS === 'true';
}

/**
 * Ad units do GAM que os scripts da Grumft chamavam (mesmos tamanhos).
 * `refreshAdUnit`: a partir da 2ª chamada o script deles pede o `_R`; só existe para alguns.
 */
export const GAM_NETWORK_CODE = '21617763507';

const SIZES_336x280 = [[336, 280], [320, 100], [300, 250], [200, 200]];
const SIZES_320x50 = [[320, 50], [300, 50]];

export const GAM_ZONES = {
  ZONA_IAB_336x280_2: { adUnit: '5498_ZONA_IAB_336x280_2', width: 336, height: 280, sizes: SIZES_336x280 },
  ZONA_IAB_336x280_3: {
    adUnit: '5498_ZONA_IAB_336x280_3',
    refreshAdUnit: '5498_ZONA_IAB_336x280_3_R',
    width: 336,
    height: 280,
    sizes: SIZES_336x280,
  },
  ZONA_IAB_336x280_5: { adUnit: '5498_ZONA_IAB_336x280_5', width: 336, height: 280, sizes: SIZES_336x280 },
  ZONA_IAB_336x280_13: { adUnit: '5498_ZONA_IAB_336x280_13', width: 336, height: 280, sizes: SIZES_336x280 },
  ZONA_IAB_728x90: {
    adUnit: '5498_ZONA_IAB_728x90',
    refreshAdUnit: '5498_ZONA_IAB_728x90_R',
    width: 728,
    height: 90,
    sizes: [[728, 90]],
  },
  ZONA_IAB_320x50: {
    adUnit: '5498_ZONA_IAB_320x50',
    refreshAdUnit: '5498_ZONA_IAB_320x50_R',
    width: 320,
    height: 50,
    sizes: SIZES_320x50,
  },
  // Sticky do rodapé: refresh 5 s depois de cada impressão visível, como no script da Grumft.
  STICK_320x50_4: {
    adUnit: '5498_STICK_320x50_4',
    refreshAdUnit: '5498_STICK_320x50_4_R',
    width: 320,
    height: 50,
    sizes: SIZES_320x50,
    refreshSeconds: 5,
  },
};

export function getGamZone(grumftZone) {
  return GAM_ZONES[String(grumftZone || '').trim()] || null;
}
